import {SequenceTopology} from 'constants/SequenceConstants';
import {BioentityQuery} from 'notebook/integrations/registry/__generated/BioentityQuery';
import {BulkBioentityLiveDataQuery} from 'notebook/structured-tables/row-updaters/__generated/BulkBioentityLiveDataQuery';

export function getTopologyValueFromBioentitySummary(
  bioentitySummary:
    | BioentityQuery['directBioentity']
    | BulkBioentityLiveDataQuery['directBioentities'][number]
): string | null {
  if (bioentitySummary.__typename === 'SequenceNode') {
    return bioentitySummary.circular ? SequenceTopology.CIRCULAR : SequenceTopology.LINEAR;
  } else {
    return null;
  }
}

export function parseTopologyFromString(value: string): SequenceTopology | null {
  switch (value.toLowerCase().trim()) {
    case SequenceTopology.CIRCULAR:
      return SequenceTopology.CIRCULAR;
    case '':
      return SequenceTopology.LINEAR;
    case SequenceTopology.LINEAR:
      return SequenceTopology.LINEAR;
    default:
      return null;
  }
}
